module.exports = __webpack_public_path__ + "static/img/success.1fd8a6cf.png";